import { render } from "./areas.vue?vue&type=template&id=8be16082"
import script from "./areas.vue?vue&type=script&lang=js"
export * from "./areas.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__